import { get } from 'lodash';

exports.getLogoSettings = (props) => {
    const logoMap = props.theme.global.logoMap;
    let organizationBrandingCode = get(props, 'theme.whitelabel.organizationBrandingCode', 'default');

    if (!logoMap[organizationBrandingCode]) {
        organizationBrandingCode = 'default';
    }

    return logoMap[organizationBrandingCode];
};



// WEBPACK FOOTER //
// ./src/helpers/styledComponentHelpers.js